import DetailsPanel from './DetailsPanel';

export default DetailsPanel;
